export default __webpack_public_path__ + "static/media/ismail.0197fa6a.webp";